/**
 * Firebase initialisation — used exclusively by the real-time chat feature.
 *
 * Firebase Auth is NOT used for app login (JWT against the FinminOS backend owns
 * that). Firebase/Firestore is only signed into with the custom token the
 * backend mints on every login/refresh and stores in sessionStorage via
 * @finmin/auth TokenStore.
 *
 * Do NOT add Firebase Auth flows (signInWithEmailAndPassword, etc.) here.
 */
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY            ?? 'AIzaSyBi_KljTM0qOA3LH7SeQfpR_hsNMo8shz8',
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN        ?? 'finmin-e9418.firebaseapp.com',
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID         ?? 'finmin-e9418',
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET     ?? 'finmin-e9418.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '315509080821',
  appId:             import.meta.env.VITE_FIREBASE_APP_ID             ?? '1:315509080821:web:2d47e5bdc69394a464fbbc',
};

// Guard against double-initialisation in HMR / StrictMode
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);
export const firestoreDb  = getFirestore(app);
